import React from 'react';
import styled, { type CSSProps } from 'libs/styled';
import { above } from '@fogia/core-web/utils/mediaqueries';

interface BlockGridWrapperProps extends CSSProps {
    children: React.ReactNode;
    lockSmallGrid?: boolean; // Locks grid to small grid (12 columns) even on larger viewports
}

const filterTransientProps = { shouldForwardProp: (prop: string) => !prop.startsWith('$') };

/**
 * BlockGridWrapper - A flexible grid wrapper for blocks and modules
 * Uses media queries for responsive behavior
 * Implements grid specs from Figma design system
 * Uses CSS variables from grid config (packages/fogia/src/config/branding/grid.ts)
 */
const BlockGridWrapperBase = styled('div', filterTransientProps)`
    width: 100%;
    height: 100%;
    display: grid;
    position: relative;

    /* Base mobile styles - always applied */
    padding-left: var(--grid-padding, 10px);
    padding-right: var(--grid-padding, 10px);
    grid-template-columns: repeat(var(--grid-columns, 12), 1fr);
    column-gap: var(--grid-gap, 10px);

    /* Desktop (tablet.lg and above) - Skip if locked to small grid */
    ${({ $lockSmallGrid }) =>
        !$lockSmallGrid &&
        `
        ${above['tablet.lg']} {
            padding-left: var(--grid-padding, 10px);
            padding-right: var(--grid-padding, 10px);
            grid-template-columns: repeat(var(--grid-columns, 24), 1fr);
            column-gap: var(--grid-gap, 10px);
        }
    `}
`;

const BlockGridWrapper: React.FC<BlockGridWrapperProps> = ({
    children,
    lockSmallGrid = false,
    // rowGap,
    ...styledProps
}) => (
    <BlockGridWrapperBase $lockSmallGrid={lockSmallGrid} {...styledProps}>
        {children}
    </BlockGridWrapperBase>
);

export default BlockGridWrapper;
